// src/actions/reportSettingsActions.js

import axios from 'axios';
import {
  GET_REPORT_SETTINGS_REQUEST,
  GET_REPORT_SETTINGS_SUCCESS,
  GET_REPORT_SETTINGS_FAIL,
  UPDATE_REPORT_SETTINGS_REQUEST,
  UPDATE_REPORT_SETTINGS_SUCCESS,
  UPDATE_REPORT_SETTINGS_FAIL,
  CREATE_REPORT_SETTINGS_REQUEST,
  CREATE_REPORT_SETTINGS_SUCCESS,
  CREATE_REPORT_SETTINGS_FAIL,
  baseURL
} from './types';

// Helper function to get auth headers
const getAuthHeaders = (isMultipart = false) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Authorization': `Bearer ${token}`,
  };
  if (!isMultipart) {
    headers['Content-Type'] = 'application/json';
  }
  return { headers };
};

// --- (CORRECTED) ACTION to GET settings ---
// This now matches your working Postman request.
export const getReportSettings = (hospitalID) => async (dispatch) => {
  try {
    dispatch({ type: GET_REPORT_SETTINGS_REQUEST });

   
    const { data } = await axios.post(
      `${baseURL}/api/appointementDoctorReportSetting/getall`, 
      { hospitalID }, // <-- Sending data in the body
      getAuthHeaders()
    );

    dispatch({ type: GET_REPORT_SETTINGS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_REPORT_SETTINGS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// --- (CORRECTED) ACTION to CREATE new settings ---
// Updated URL to be consistent with the getall endpoint.
export const createReportSettings = (formData) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_REPORT_SETTINGS_REQUEST });
        
        // ✅ Updated the URL to the correct endpoint path
        const { data } = await axios.post(`${baseURL}/api/appointementDoctorReportSetting/create`, formData, getAuthHeaders(true));

        dispatch({
            type: CREATE_REPORT_SETTINGS_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: CREATE_REPORT_SETTINGS_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};

// --- (CORRECTED) ACTION to UPDATE existing settings ---
// Updated URL to be consistent with the getall endpoint.
export const updateReportSettings = (formData) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_REPORT_SETTINGS_REQUEST });

        // ✅ Updated the URL to the correct endpoint path
        // Using PATCH is standard for updates. If your API uses POST, you can change this.
        const { data } = await axios.patch(`${baseURL}/api/appointementDoctorReportSetting/update`, formData, getAuthHeaders(true));

        dispatch({
            type: UPDATE_REPORT_SETTINGS_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: UPDATE_REPORT_SETTINGS_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};